import { useState } from 'react';
import { PageHeader, Tabs } from '@/components/ui/layout';
import { OwnerAlertsFeed } from './OwnerAlertsFeed';
import { OwnerAlertSettingsForm } from './OwnerAlertSettingsForm';
import { useOwnerCapability } from './owner-nav';
import { OwnerAlertEmailPolicy } from './OwnerAlertEmailPolicy';
import { OwnerEmailPanel } from './OwnerEmailPanel';
import { useTranslation } from '@/lib/i18n';

/** Owner console → Alerts (docs/SYNC.md; plan §3.6): the feed and the global channel settings. */
export function OwnerAlertsPage() {
  const [tab, setTab] = useState('feed');
  const canSeeSettings = useOwnerCapability('alert_settings.read');
  const canSeeFacilityEmail = useOwnerCapability('email.read');
  const { t } = useTranslation('admin');
  return (
    <>
      <PageHeader
        title="Alerts"
        description="Every stale warning, lock, unlock, fingerprint mismatch, failed update and silent customer — recorded here even when email or SMS fails."
      />
      <Tabs
        active={tab}
        onChange={setTab}
        tabs={[
          { id: 'feed', label: 'Feed' },
          ...(canSeeSettings ? [{ id: 'settings', label: 'Settings' }, { id: 'email', label: t('alert_email_tab') }] : []),
          ...(canSeeFacilityEmail ? [{ id: 'facility_email', label: 'Facility email' }] : []),
        ]}
      />
      {tab === 'feed' && <OwnerAlertsFeed />}
      {tab === 'settings' && canSeeSettings && <OwnerAlertSettingsForm />}
      {tab === 'email' && canSeeSettings && <OwnerAlertEmailPolicy />}
      {tab === 'facility_email' && canSeeFacilityEmail && <OwnerEmailPanel />}
    </>
  );
}
